/**
 * Created by zhengyf on 2017/9/25.
 *
 * params:
 *  catData: {} 所有一级类目
 */

;(function () {
    homeBannerCtrl.$inject = ['$interval'];
    angular
        .module('DSSXAPP')
        .component('homeBanner', {
            template:'<div class="home-banner"><div class="banner-bg-top"></div><div class="banner-bg-bottom"></div><div class="banner-content-wrap"><div class="banner-category-ta"><div class="b-c-col b-c-left"><div class="b-c-menu-view"><div class="b-c-menu-title"><i class="iconfont icon-category"></i> <span>MY MARKETS</span></div><ul class="b-c-menu-list"><li class="b-c-menu-item" ng-repeat="menuItem in vm.d.homeMainCate track by $index"><a ng-href="cate-detail.html?catId={{menuItem.catId}}&cate={{menuItem.enNameEncode}}" target="_blank" class="util-ellipsis" ng-bind="menuItem.enName"></a></li><li class="b-c-menu-item"><a href="javascript:;" class="vmore-link" ng-class="{\'bg\': vm.d.showVmoreLink}" ng-mouseover="vm.d.showVmoreLink = true" ng-mouseleave="vm.d.showVmoreLink = false">All Categories <i class="iconfont icon-more"></i></a><div class="vmore-hover-fix" ng-mouseover="vm.d.showVmoreLink = true" ng-mouseleave="vm.d.showVmoreLink = false" ng-show="vm.d.showVmoreLink"></div><ul class="vmore-menu-list" ng-mouseover="vm.d.showVmoreLink = true" ng-mouseleave="vm.d.showVmoreLink = false" ng-show="vm.d.showVmoreLink"><li class="vmore-menu-item" ng-repeat="item in vm.d.homeExpandCate track by $index"><div ng-repeat="cat in item track by $index"><a ng-href="cate-detail.html?catId={{cat.catId}}&cate={{cat.enNameEncode}}" target="_blank" ng-bind="cat.enName"></a> <span class="divider" ng-show="$index !== item.length - 1">/</span></div></li></ul></li></ul></div></div><div class="b-c-fix-content"><div class="b-c-col b-c-fix-right dp-n"><a href="javascript:;" class="select-img">Selected Suppliers</a><div class="right-wrapper"><a href="javascript:;"><div class="title">Auto Lighting</div><div class="view-more">Source Now</div><div class="item-banner"><img src="images/aliIndex/right-banner1.png"></div></a> <a href="javascript:;"><div class="title">Auto Electronics</div><div class="view-more">Source Now</div><div class="item-banner"><img src="images/aliIndex/right-banner2.png"></div></a><a href="javascript:;"><div class="title">Auto Driving System</div><div class="view-more">Source Now</div><div class="item-banner"><img src="images/aliIndex/right-banner3.png"></div></a></div></div><div class="b-c-banner-wrap b-c-banner-wrap-m-r" ng-mouseover="vm.f.initAutoTabBanner(false, 4000)" ng-mouseleave="vm.f.initAutoTabBanner(true, 4000)"><div class="banner-main-wrap"><span class="b-c-icon-wrap-bg b-c-icon-prev" ng-click="vm.f.tabBannerView(\'prev\', vm.d.oldBannerIndex)"><i class="iconfont icon-back b-c-icon"></i></span> <span class="b-c-icon-wrap-bg b-c-icon-next" ng-click="vm.f.tabBannerView(\'next\', vm.d.oldBannerIndex)"><i class="iconfont icon-more b-c-icon"></i></span><div class="b-c-banner-list-wrap"><div class="b-c-banner-list" ng-style="vm.d.bannerLeft"><a href="javascript:;" class="ii" ng-repeat="item in vm.d.bannerList track by $index" style="background-image: url({{item.src}})"></a></div></div><ul class="ui-switchable-nav"><li class="ui-switchable-trigger" ng-repeat="item in vm.d.bannerList track by $index" ng-bind="$index + 1" ng-class="{\'current\': item.selected}" ng-mouseover="vm.f.tabBannerView(\'normal\', $index)"></li></ul></div></div></div></div></div></div>',
            bindings: {
                catData: '<'
            },
            controllerAs: 'vm',
            controller: homeBannerCtrl
        });

    function homeBannerCtrl($interval) {

        this.$onInit = onInit;
        this.$onChanges = bindingsOnChanges;

        var vm = this;

        vm.d = {
            showVmoreLink: false, // 是否显示All Categoryies menu
            bannerList: [
                {
                    src: '../../../images/aliIndex/01.png',
                    selected: true
                },
                {
                    src: '../../../images/aliIndex/02.png'
                },
                {
                    src: '../../../images/aliIndex/03.png'
                }
            ], // banner图列表
            bannerLeft: {
                transform: 'translateX(0)'
            },
            oldBannerIndex: 0,
            watchBannerFlag: false,
            homeMainCate: [], // 左侧8个一级类目 // todo 点击跳转到二级类目
            homeExpandCate: [], //
            catFirstListAll: [], //
        };

        vm.f = {
            tabBannerView: tabBannerView,
            initAutoTabBanner: initAutoTabBanner

        };

        var BANNER_LIST_LENGTH = vm.d.bannerList.length;
        var timer = '';


        // ==============function====================


        function onInit() {
            console.log('[HomeBanner init: ]');
            initAutoTabBanner(true, 4000);
        }

        /**
         * 自动轮播
         * @param time
         */
        function initAutoTabBanner(flag, time) {
            if (flag) {
                timer = $interval(function () {
                    tabBannerView('next', vm.d.oldBannerIndex);
                }, time);
            } else {
                $interval.cancel(timer);
            }
        }

        /**
         * 切换banner
         * @param index
         */
        function tabBannerView(mode, index) {
            var i = tabBannerMode(mode, index);
            vm.d.oldBannerIndex = i;
            initBannerList(i);
            vm.d.bannerLeft = setBannerLeft(i);
        }

        /**
         * 获得banner图下标
         * @param mode
         * @param index
         * @returns {*}
         */
        function tabBannerMode(mode, index) {
            switch (mode) {
                case 'prev':
                    return index - 1 < 0 ? (BANNER_LIST_LENGTH - 1) : index - 1;
                case 'next':
                    return index + 1 > (BANNER_LIST_LENGTH - 1) ? 0 : index + 1;
                default:
                    return index;
            }
        }

        /**
         * 初始化bannerList
         * @param index
         */
        function initBannerList(index) {
            var list = vm.d.bannerList;
            for (var i = 0, len = list.length; i < len; i++) {
                list[i].selected = false;
            }
            list[index].selected = true;
        }

        /**
         * 设置banner图left
         * @param index
         */
        function setBannerLeft(index) {
            return {
                transform: 'translateX(' + '-' + index * 10 + '%' + ')'
            };
        }

        /**
         * 更新父组件传入的一级类目
         * @param changes
         */
        function bindingsOnChanges(changes) {
            if (changes.catData) {
                vm.d.homeMainCate = angular.copy(vm.catData.home_main_cate) || [];
                vm.d.homeExpandCate = angular.copy(vm.catData.home_expand_cate) || [];
                encodeMain(vm.d.homeMainCate);
                encodeExpand(vm.d.homeExpandCate);
            }
        }

        function encodeMain(list) {
            for (var i = 0; i < list.length; i++) {
                list[i]['enNameEncode'] = encodeURIComponent(list[i]['enName']);
            }
        }

        function encodeExpand(list) {
            for (var i = 0; i < list.length; i++) {
                for (var j = 0; j < list[i].length; j++) {
                    list[i][j]['enNameEncode'] = encodeURIComponent(list[i][j]['enName']);
                }

            }
        }


    }

})();